import { RootState } from '../index';

export const selectPromoCodes = (state: RootState) => state.promoCodes.promoCodes;

export const selectUnUsedPromoCode = (state: RootState) => {
  return state.promoCodes.promoCodes[state.promoCodes.promoCodes.length - 1];
};
export const hasUnUsedPromoCodeSelector = (state: RootState) => {
  return state.promoCodes.promoCodes.length > 0;
};

export const selectPromoCodeModalIsOpen = (state: RootState) => state.promoCodes.modalIsOpen;

export const selectPromoCodeTimerData = (state: RootState) => state.promoCodes.timer;
